var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1132 0.31952C12.5448 -0.106506 13.2446 -0.106506 13.6763 0.31952C14.1079 0.745547 14.1079 1.43627 13.6763 1.8623L7.78154 7.68048C7.34991 8.10651 6.65009 8.10651 6.21846 7.68048L0.323724 1.8623C-0.107908 1.43627 -0.107908 0.745546 0.323724 0.31952C0.755356 -0.106507 1.45517 -0.106507 1.8868 0.31952L7 5.36631L12.1132 0.31952Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.cba90fa44a17a5f8dd92b1c2202f665e.svg";
export { ForwardRef as ReactComponent };